import { Pagination } from 'components/Pagination'
import { PropertyCard } from 'components/Property'
import { ComponentType } from 'react'
import { Container, Row } from 'reactstrap'
import { up } from 'styled-breakpoints'
import styled from 'styled-components'

const Wrapper = styled.div`
  padding-bottom: 10px;

  ${up('sm')} {
    padding-bottom: 24px;
  }
`

interface Props {
  properties: any[]
  total: number
  limit: number
  page: number
  loading: boolean
}

export const Properties: ComponentType<Props> = ({ properties, total, limit, page, loading }) => (
  <Wrapper>
    <Container>
      <Row xs="1" sm="3" md="4" lg="5">
        {properties.map((property: any) => (
          <div key={property.uuid} className="py-10 px-10">
            <PropertyCard property={property} />
          </div>
        ))}
      </Row>
      <Pagination className="mt-50" total={total} limit={limit} page={page} loading={loading} />
    </Container>
  </Wrapper>
)
